import '../assets/NcFormBox-yb5gffYX.css';
import { defineComponent, useCssModule, provide } from "vue";
import { N as NC_FORM_BOX_CONTEXT_KEY } from "./useNcFormBox-Djlh582y.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcFormBox",
  props: {
    row: { type: Boolean, default: false }
  },
  setup(__props) {
    const style = useCssModule();
    provide(NC_FORM_BOX_CONTEXT_KEY, {
      isInFormBox: true,
      formBoxItemClass: style.ncFormBox__item
    });
    return { __sfc: true, style };
  }
});
const ncFormBox = "_ncFormBox_8a2Kh";
const ncFormBox_row = "_ncFormBox_row_3x4Kh";
const ncFormBox__item = "_ncFormBox__item_fTqeW";
const ncFormBox_col = "_ncFormBox_col_R7DeP";
const style0 = {
  "material-design-icon": "_material-design-icon_imcru",
  ncFormBox,
  ncFormBox_row,
  ncFormBox__item,
  ncFormBox_col
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  _vm._self._setupProxy;
  return _c("div", { class: [_vm.$style.ncFormBox, _vm.row ? _vm.$style.ncFormBox_row : _vm.$style.ncFormBox_col] }, [_vm._t("default", null, { "itemClass": _vm.$style.ncFormBox__item })], 2);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles,
  null
);
const NcFormBox = __component__.exports;
export {
  NcFormBox as N
};
//# sourceMappingURL=NcFormBox-Bd7m8ffs.mjs.map
